import { Component } from "react";

import BillService from "../../../services/Bill";
import ChequePayementDetail from "./ChequePayementDetail";
import EnlignePayementDetail from "./EnlignePayementDetail";
import EspecePayementDetail from "./EspecePayementDetail";
import VirementPayementDetail from "./VirementPayementDetail";
import WallerPayementDetails from "./WallerPayementDetails";
import PrelevementPayementDetails from "./PrelevementPayementDetails";
import EspecePayementDetailV2 from "./EspecePayementDetailV2";

class ListTotalPayementBill extends Component {
  state = {
    alert_message: "",
    avancePayements: [],
  };
  constructor(props) {
    super(props);

    this.state = {
      alert_message: "",
      avancePayements: [],
    };
  }

  payementDetails(typePayement, payementAvance) {
    if (typePayement === "Espéce") {
      // return <EspecePayementDetail payementAvance={payementAvance} />;
      return (
        <EspecePayementDetailV2
          payementAvance={payementAvance}
          hideReceipt={this.props.hideReceipt}
        />
      );

    } else if (typePayement === "En ligne") {
      return <EnlignePayementDetail payementAvance={payementAvance} />;
    } else if (typePayement === "Chéque / Traites") {
      return <ChequePayementDetail payementAvance={payementAvance} />;
    } else if (typePayement === "Virement") {
      return <VirementPayementDetail payementAvance={payementAvance} />;
    }else if (typePayement === "Wallet") {
      return (
        <WallerPayementDetails
          payementAvance={payementAvance}
          hideReceipt={this.props.hideReceipt}
        />
      );
    }else if (typePayement === "Prélevement") {
      return <PrelevementPayementDetails payementAvance={payementAvance} />;
    }
  }
  render() {
    if (this.state.alert_message === "error") {
      return <div class="col-12"></div>;
    } else if (this.props.payementInformations) {
      return (
        <div class="row">
          <div className="col-12">
            <div className="card ">
              <div className="card-header">
                <h3 className="card-title">Les payements </h3>
              </div>
              <div className="card-body">
                {this.props.payementInformations &&
                  this.props.payementInformations.map((payementAvance) => (
                    <div className="post ">
                      {this.payementDetails(
                        payementAvance?.typePayement,
                        payementAvance
                      )}
                      <br />
                      <br />
                    </div>
                  ))}
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.props.totalPayementInformation) {
      return (
        <div class="row">
          <div className="col-12">
            <div className="card ">
              <div className="card-header">
                <h3 className="card-title">payement sur la facture</h3>
              </div>
              <div className="card-body">
                <div className="post ">
                  <div className="row">
                    <div className="user-block">
                      Cette facture est payées dans un groupe :{" "}
                      <ul>
                        {" "}
                        {this.props.totalPayementInformation?.factureTitle &&
                          this.props.totalPayementInformation?.factureTitle.map(
                            (factureInformation) => (
                              <li> {factureInformation} </li>
                            )
                          )}{" "}
                      </ul>
                    </div>{" "}
                  </div>

                  {this.payementDetails(
                    this.props.totalPayementInformation?.payementInformation
                      .typePayement,
                    this.props.totalPayementInformation?.payementInformation
                  )}
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div class="col-12"></div>;
    }
  }
}
export default ListTotalPayementBill;
